// Pack hover preview — tap-to-reveal fallback for touch devices.
// Desktop/keyboard get the reveal for free from CSS (:hover / :focus-within);
// this only handles devices where hover doesn't exist.
document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('[data-pack-card]');
  if (!cards.length) return;

  var isTouch = window.matchMedia('(hover: none)').matches;
  if (!isTouch) return;

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Let the actual add-to-cart button work normally.
      if (e.target.closest('[data-pack-cta]')) return;

      var wasActive = card.classList.contains('is-active');
      cards.forEach(function (c) {
        c.classList.remove('is-active');
      });
      if (!wasActive) card.classList.add('is-active');
    });
  });
});


//Salepify  custom
// Pack card add-to-cart — go through /cart/add.js instead of a native form POST.
// The free gift app injects its gift by wrapping window.fetch, so a plain form
// submit never reaches it and the gift silently never lands in the cart.
// The liquid <form> stays intact as the no-JS fallback.
(function () {
  // The snippet can be rendered more than once on a page; bind only once.
  if (window.packCardsAjaxAddBound) return;
  window.packCardsAjaxAddBound = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    if (!form.closest('[data-pack-card]')) return;

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value;
    // Can't tell which variant — leave the native submit alone.
    if (!variantId) return;

    e.preventDefault();

    var button = form.querySelector('[data-pack-cta]');
    setBusy(button, true);

    // Read window.fetch at call time, never at load time: the gift app installs
    // its wrapper asynchronously and a cached reference would miss it.
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { ok: res.ok, data: data };
          });
      })
      .then(function (result) {
        if (!result.ok) {
          console.error('Pack cards — add to cart failed:', result.data);
          if (result.data.description) window.alert(result.data.description);
          setBusy(button, false);
          return;
        }
        // Same destination as the native submit. The gift is already in the
        // cart by now — it rode along in the request above.
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .catch(function (error) {
        console.error('Pack cards — add to cart error:', error);
        setBusy(button, false);
        form.submit();
      });
  });

  function setBusy(button, isBusy) {
    if (!button) return;
    button.disabled = isBusy;
    if (isBusy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }
})();